import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { SharedService } from '@app/shared/services/shared.service';
import { PatternValidator, Validators } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';

import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { ItemProps } from '@app/interfaces';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { TranslateService } from '@ngx-translate/core';
import { circle } from 'leaflet';
import { MapService } from '@app/shared/services/map.service';

@Injectable({
  providedIn: 'root'
})
export class DistrictsService extends RootService {
  searchKey = 'keyword';
  constructor(
    router: Router,
    api: ApiRequestService,
    shared: SharedService,
    permissionsService: PermissionsService,
    private toArabic: ToArabicPipe,
    private translateService: TranslateService,
    private mapService: MapService
  ) {
    super(router, api, permissionsService, shared);
    this.permissionsKey = 'district';
  }

  refactorFilters(filters: any): any {
    super.refactorFilters(filters);
    /** set perPage to 50 */
    filters.per_page = 50;

    return filters;
  }

  routerPrefix(val: string = '') {
    return val ? val : 'districts';
  }
  refactorFormBeforeSubmit(formValue: any) {
    console.log('formValue', formValue);

    if (formValue['neighborhoods']) {
      if (formValue['neighborhoods'].length > 1) {
        // let lastItem = formValue['districts'][formValue['districts'].length - 1];
        // console.log('neighborhoods', formValue['neighborhoods']);
        if (!formValue['neighborhoods'][formValue['neighborhoods'].length - 1]['name']) {
          formValue['neighborhoods'].pop();
        }
        formValue['neighborhoods'].forEach((e: any) => {
          e.sub_neighborhoods = e.sub_neighborhoods ? e.sub_neighborhoods : [];
        });
      }
      formValue['neighborhoods'] = formValue['neighborhoods'].map((item: any) => {
        item['population'] = parseInt(item['population']);
        if (item['id'] === null) {
          delete item['id'];
        }
        if (item['neighborhood_points'] && Array.isArray(item['neighborhood_points'][0])) {
          item['neighborhood_points'] = item['neighborhood_points'][0];
        } else item['neighborhood_points'] = item['neighborhood_points'];

        return item;
      });
    }
    formValue['points']['zoom'] = this.mapService.currentZoom ? this.mapService.currentZoom : 12;

    return formValue;
  }

  listPrepareOperations(data: any) {
    super.listPrepareOperations(data);
    data['data'].forEach((element: any) => {
      element['neighborhoods_count'] = this.setPrefixTd(element['neighborhoods_count'], 'neighborhoods_count');
      element['sub_neighborhoods_count'] = this.setPrefixTd(element['sub_neighborhoods_count'], 'neighborhoods_count');
      element['units_count'] = this.setPrefixTd(element['units_count'], 'units_count');
    });
    this.mapService.createdPoints = data['data'];
    return data;
  }

  setPrefixTd(num: number, name: string) {
    let str = '';
    if (!num) {
      str = 'لايوجد';
    } else {
      str =
        num > 10 || num === 1
          ? `${this.toArabic.transform(num.toString())} ${
              this.translateService.instant(`${this.cid}`)[`single${name}`]
            }`
          : `${this.toArabic.transform(num.toString())} ${
              this.translateService.instant(`${this.cid}`)[`multi${name}`]
            }`;
    }
    return str;
  }

  get featureProps(): ItemProps[] {
    return [
      {
        name: 'status',
        prop: 'status',

        form: {
          formFieldType: 'toggle',
          Validators: [],
          cssClass: 'green',
          initValue: true,
          groupBy: {
            tabGroup: {
              tabGroupName: 'vehicles_main_group1',
              tabName: 'districts.form_tab_1'
            }
          }
        }
      },
      {
        name: 'name',
        prop: 'name',
        list: {
          sortable: true,
          action: {
            name: 'showContracts'
          }
        },
        form: {
          name: 'district_name',
          Validators: [Validators.required, Validators.minLength(3), Validators.maxLength(50)],
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'vehicles_main_group1',
              tabName: 'districts.form_tab_1',
              steps: true
            }
          }
        }
      },
      {
        name: 'points',
        prop: 'points',
        form: {
          name: 'points',
          Validators: [Validators.required],
          formFieldType: 'map_points_select',
          map: {
            // color: 'red',
            marker: true
          },
          groupBy: {
            tabGroup: {
              tabGroupName: 'vehicles_main_group1',
              tabName: 'districts.form_tab_1',
              steps: true
            }
          }
        }
      },

      {
        name: 'neighborhoods_count',
        prop: 'neighborhoods_count',
        list: {
          sortable: true,
          cellInnerCssClass: 'arabicFont'
        }
      },
      {
        name: 'sub_neighborhoods_count',
        prop: 'sub_neighborhoods_count',
        list: {
          sortable: true,
          cellInnerCssClass: 'arabicFont'
        }
      },
      {
        name: 'units_count',
        prop: 'units_count',
        list: {
          sortable: true,
          cellInnerCssClass: 'arabicFont'
        }
      },
      {
        name: 'neighborhoods',
        prop: 'neighborhoods',
        form: {
          formFieldType: 'formArray',
          name: 'neighborhoods',
          groupBy: {
            tabGroup: {
              tabGroupName: 'vehicles_main_group1',
              tabName: 'districts.form_tab_2'
            }
          },
          arrayForm: [
            {
              name: 'id',
              prop: 'id',
              list: {
                hidden: true
              },
              form: {
                formFieldType: 'hidden',
                Validators: [],
                cssClass: 'green',
                initValue: null
              }
            },
            {
              name: 'status',
              prop: 'status',
              list: {
                hidden: false
              },
              groupFields: [
                {
                  prop: 'default_contact',
                  type: 'boolean'
                }
              ],
              form: {
                formFieldType: 'toggle',
                Validators: [],
                cssClass: 'green',
                initValue: true
              }
            },
            {
              name: 'name',
              prop: 'name',
              list: {
                hidden: false
              },
              // groupFields: [
              //   {
              //     prop: 'default_contact',
              //     type: 'boolean'
              //   }
              // ],
              form: {
                name: 'neighborhood_name',
                formFieldType: 'text',
                Validators: [Validators.required, Validators.minLength(3), Validators.maxLength(50)],
                grid: {
                  gt_lg: '50%',
                  lt_xl: '50%',
                  lt_lg: '50%',
                  lt_md: '50%',
                  lt_sm: '100%'
                }
              }
            },
            {
              name: 'population',
              prop: 'population',
              list: {
                hidden: false
              },
              // groupFields: [
              //   {
              //     prop: 'default_contact',
              //     type: 'boolean'
              //   }
              // ],
              form: {
                formFieldType: 'text_number',
                Validators: [CustomValidators.numberValidator],
                grid: {
                  gt_lg: '50%',
                  lt_xl: '50%',
                  lt_lg: '50%',
                  lt_md: '50%',
                  lt_sm: '100%'
                }
              }
            },
            {
              name: 'sub_neighborhoods',
              prop: 'sub_neighborhoods',
              list: {
                hidden: false
              },
              groupFields: [
                {
                  prop: 'sub_neighborhoods',
                  type: 'input_array'
                }
              ],
              form: {
                formFieldType: 'ng_added_select_multiple'
                // Validators: [Validators.required]
                // grid: {
                //   gt_lg: '50%',
                //   lt_xl: '50%',
                //   lt_lg: '50%',
                //   lt_md: '50%',
                //   lt_sm: '100%'
                // }
              }
            },
            {
              name: 'neighborhood_points',
              prop: 'neighborhood_points',
              form: {
                name: 'neighborhood_points',
                Validators: [Validators.required],
                formFieldType: 'map_points_select',
                map: {
                  childMap: true,
                  // color: 'green',
                  marker: true
                }
              }
            }
          ]
        }
      }
    ];
  }
}
